import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { mobileNavigation } from 'src/app/store/navigation';
import { APP_CONFIG } from 'src/app/app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'smart-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent {
  urlupload = environment.URLUPLOAD
  avatar = APP_CONFIG.avatar;
  email = APP_CONFIG.email;
  user = APP_CONFIG.user;
  logo = sessionStorage.getItem("logo_small") && sessionStorage.getItem("logo_small") !== 'null' ? sessionStorage.getItem("logo_small") : APP_CONFIG.logo;;
  appName = APP_CONFIG.appName;

  constructor(private store: Store<any>,   private router: Router,) { }

  openMobileNav($event: MouseEvent) {
    $event.preventDefault();
    this.store.dispatch(mobileNavigation({open: true}));
  }

  home(){
    this.router.navigate(["/dashboard"]).then(() => {
      window.location.reload();
    });
  }

}
